import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { LeadViewTimelineStepIcon } from "./campaign-view-timeline-step-icon";
import { LeadViewTimelineProps } from "./campaign-view-timeline.props";
import { QontoConnector } from "./campaign-view-timeline.constant";
import "./campaign-view-timeline.scss";
import { getCampaignDetails } from "../../../../api/campaign";
import { formatDateTime } from "../../../../utils/utils";

const CampaignViewTimeline: React.FC<LeadViewTimelineProps> = (props: any) => {
  const { selectedCampaignId, setLoading, setUpdatedDate, setAlertMessage,  setAlertType, setAlertOpen} = props;
  const [historyDetails, setHistoryDetails] = useState<any>(null);
  const handleEditOpen = () => {};
  const fetchCampiagnDetails = async () => {
    setLoading(true);
    try {
      const response = await getCampaignDetails(selectedCampaignId);
      setHistoryDetails(response?.data?.data?.campaignHistories || []);
      setTimeout(() => setLoading(false), 1000);
      setUpdatedDate(formatDateTime(response?.data?.data?.updated_at))
    } catch (error: any) {
      setAlertMessage(error?.response?.data?.message ||  "An error occurred while saving the lead.");
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };
  useEffect(() => {
  // Comment out the real API call
  fetchCampiagnDetails();

}, [selectedCampaignId]);

  const formatFieldName = (fieldName: string): string => {
    const fieldMap: Record<string, string> = {
      actual_cost: "Actual Cost",
      budgeted_cost: "Budgeted Cost",
      campaignOwner: "Campaign Owner",
      created_by: "Created By",
      modified_by: "Modified By",
      deleted_by: "Deleted By",
      description: "Description",
      end_date: "End Date",
      expected_response: "Expected Response",
      expected_revenue: "Expected Revenue",
      id: "Campaign ID",
      name: "Campaign Name",
      owner_id: "Campaign Owner",
      start_date: "Start Date",
      status: "Status",
      type: "Campaign Type",
      preferred_contact_mode:"Preferred Contact Mode",
      company:"Company",
      title: "Title",
      location: "Location",
      meetStartTime: "From Date and Time",
      meetEndTime: "To Date and Time",
      host_id: "Host",
      participants: "Participants",
      related_to: "Related To",
      subject: "Subject",
      due_date: "Due Date",
      priority: "Priority",
      task_status: "Task Status",
      reminder: "Reminder",
      owner: "Owner",
      closed_time: "Closed Time",
      all_day:"All Day",
      // New call-related fields
      call_owner_id: "Call Owner",
      related_to_campaign_id: "Related To Campaign",
      related_to_lead_id: "Related To Lead",
      outgoing_call_status: "Outgoing Call Status",
      call_start_time: "Call Start Time",
      call_purpose: "Call Purpose",
      call_agenda: "Call Agenda",
      notes: "Notes",
      call_duration: "Call Duration",
      call_results: "Call Results",
      call_type: "Call Type",
      callFor: "Call For",
      cancel_notes: "Cancel Notes",
};


    return fieldMap[fieldName] || fieldName;
  };
  const renderFormattedDescription = (description?: string) => {
  if (!description) return null;

  const parts = description.split(/(<b>.*?<\/b>)/g);

  return parts.map((part, index) => {
    if (part.startsWith("<b>") && part.endsWith("</b>")) {
      return <b key={index}>{part.substring(3, part.length - 4)}</b>;
    }
    return <span key={index}>{part}</span>;
  });
};
  const groupByDate = (
    histories: any[]
  ): Record<string, { label: string; date: string }[]> => {
    return histories.reduce(
      (acc, history) => {
        const date = new Date(history.created_at).toLocaleDateString();
        if (!acc[date]) {
          acc[date] = [];
        }

        const createdBy = history.createdBy
          ? `- By ${history.createdBy.first_name} ${history.createdBy.last_name}`
          : "";
        acc[date].push({
          label: (
            <span>
              <span>
                <b>{formatFieldName(history.field_name)}{" "}</b>{renderFormattedDescription(history.description)}{" "}
              </span>
              <span className="campaign-list-view-timeline-info-bar-box-steps-sub">
                {" "}
                {createdBy}
              </span>
            </span>
          ),
          date: formatDateTime(history.created_at),
        });

        return acc;
      },
      {} as Record<string, { label: string; date: string }[]>
    );
  };

  const steps: Record<string, { label: string; date: string }[]> =
    historyDetails ? groupByDate(historyDetails) : {};

  return (
    <div className="campaign-list-view-timeline-info">
      <div className="campaign-list-view-timeline-info-header">
        <div className="campaign-list-view-timeline-info-header-text">Timeline</div>
      </div>
      {Object.entries(steps).map(([date, stepData], index) => (
        <div className="campaign-list-view-timeline-info-bar-box" key={index}>
          <div className="campaign-list-view-timeline-info-bar-box-date">
            {date}
          </div>
          <div className="campaign-list-view-timeline-info-bar-box-steps">
            <Box sx={{ width: "100%" }}>
              <Stepper
                activeStep={stepData.length}
                connector={<QontoConnector />}
                orientation="vertical"
                sx={{ gap: 0, p: 0, m: 0 }}
              >
                {stepData.map((data, idx) => (
                  <Step key={idx}>
                    <StepLabel StepIconComponent={LeadViewTimelineStepIcon}>
                      <div className="campaign-list-view-timeline-info-bar-box-steps-main-sub">
                        <div className="campaign-list-view-timeline-info-bar-box-steps-main">
                          {data.label}
                        </div>
                        <div className="campaign-list-view-timeline-info-bar-box-steps-sub">
                          {data.date}
                        </div>
                      </div>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CampaignViewTimeline;
